import styled from 'styled-components';

const StyledTopContainer = styled.div`
	display: grid;
	grid-template-columns: 30% 40% 30%;
	align-items: center;
	height: 80px;
	padding: 0 20px;
	border-bottom: 1px solid rgba(217, 217, 217, 0.1);
`;

const StyledBackButtonContent = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;

	img {
		width: 6px;
		height: 10px;
	}
`;

const StyledItemPrice = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
	justify-self: end;
`;

export { StyledBackButtonContent, StyledItemPrice, StyledTopContainer };
